import * as React from "react";
function SvgGplus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        d="M18.7 14.62C19.16 18 17.76 23 12 23a7 7 0 114.7-12.17 24.65 24.65 0 00-2 2.07 3.93 3.93 0 00-2.71-1 4.13 4.13 0 000 8.25 3.45 3.45 0 003.77-2.75H12v-2.78zm1.66 1.85v-1.72h2.52v-2.43h1.73v2.42H27v1.73h-2.42V19h-1.7v-2.53z"
        fill="#fff"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGplus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
